export default "__VITE_ASSET__zLS7UTkE__"